export default "__VITE_ASSET__dc9631f9__"